<template>
  <div class="ticket-message-header">

    <section class="left-section">
      <div style="display: flex; align-items: flex-start; gap: 1.5em">
        <FeatherIcon
          class="left-menu-icon"
          style="margin-top: 1.05em"
          icon="MenuIcon"
          size="20"
          @click="[ticketStore.setToggleLeftSidebar(true),ticketStore.setToggleRightSidebar(false)]"
        />

        <div>
          <p class="ticket-title">
            {{ header.title || 'Missing Ticket Title ❓' }}
          </p>
          <p class="ticket-detail">
            {{ $t('ticket.ticket') }} #<strong>{{ header.ticketNum || "Missing" }} </strong> {{
              $t('ticket.created_at')
                .toLowerCase()
            }} <strong>{{ header.createdAt | formatShortDate }}</strong>
          </p></div>
      </div>

    </section>

    <section class="right-section">
      <!--      <b-dropdown-->
      <!--        id="dropdown-right"-->
      <!--        size="sm"-->
      <!--        variant="link"-->
      <!--        toggle-class="text-decoration-none"-->
      <!--        no-caret-->
      <!--        right-->
      <!--        text="Right align"-->
      <!--      >-->
      <!--        <template-->
      <!--          #button-content-->
      <!--          class="dropdown-button"-->
      <!--        >-->
      <!--          <FeatherIcon-->
      <!--            icon="MoreVerticalIcon"-->
      <!--            size="16"-->
      <!--          />-->
      <!--        </template>-->
      <!--        <b-dropdown-item @click="$emit('delete')">-->
      <!--          {{ $t("ticket.delete") }}-->
      <!--        </b-dropdown-item>-->
      <!--      </b-dropdown>-->

      <div
        v-if="!roleStore.canUserDeleteAssignee"
        class="dropdown-menu-container"
        @click="toggleDropdown = !toggleDropdown"
      >
        <FeatherIcon
          v-b-tooltip.hover
          :title="$t('ticket.delete_ticket_required_access')"
          icon="MoreVerticalIcon"
          size="18"
          class="menu-icon"
        />
      </div>

      <div
        v-else
        class="dropdown-menu-container"
        @click="toggleDropdown = !toggleDropdown"
      >
        <FeatherIcon
          icon="MoreVerticalIcon"
          size="18"
          class="menu-icon"
        />

        <ul
          v-if="toggleDropdown"
          class="dropdown-menu-list"
        >
          <li
            class="dropdown-menu-item"
            @click="$emit('delete')"
          >
            {{ $t("ticket.delete") }}
          </li>
        </ul>

      </div>

      <FeatherIcon
        v-if="ticketStore.toggleRightSidebar"

        class="menu-icon"
        style="margin-top: 0.15em"

        icon="XIcon"
        size="20"
        @click="ticketStore.setToggleRightSidebar()"
      />
      <FeatherIcon
        v-else
        class="menu-icon"
        style="margin-top: 0.15em"

        icon="MenuIcon"
        size="20"
        @click="[ticketStore.setToggleRightSidebar(), windowWidth < 1000 && ticketStore.setToggleLeftSidebar(false)]"
      />
    </section>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BTooltip } from 'bootstrap-vue'
import useTicketStore from '@/store-pinia/useTicketStore'
import { ref } from '@vue/composition-api'
import useWidth from '@/composibles/useWidth'
import useRoleStore from '@/store-pinia/useRoleStore'

export default {
  components: { BDropdown, BDropdownItem, BTooltip },
  props: {
    header: {
      type: Object,
      default: () => ({
        id: 'id',
        title: 'title',
        createdAt: 'createdAt',
        ticketNum: 'ticketNum',
      }),
    },
  },
  setup() {
    const { windowWidth } = useWidth()
    const ticketStore = useTicketStore()
    const roleStore = useRoleStore()
    const toggleDropdown = ref(false)
    return {
      ticketStore,
      toggleDropdown,
      windowWidth,
      roleStore,
    }
  },
}
</script>

<style lang="scss" scoped>
.right-section{
  //align-items: center;
  display: flex;
  gap: 1em;
  //margin-bottom: 1em;
  margin-top: 0.75em;
  margin-right: 0.5em;
}

.menu-icon{
  color: gray;
  cursor: pointer;
  &:hover{
    scale: 1.1;
    color: #9F6096;
  }
}
.left-menu-icon{
  @extend .menu-icon;
  @media (min-width: 1000px) {
    display: none;
  }
}
.ticket-message-header{
  display:flex;
  justify-content: space-between;
  padding: 1em;

  .ticket-title{
    text-transform: capitalize ;
    font-weight: 600;
    font-size: 1.20rem;
    margin-bottom: 0.20em;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 500px;

    @media screen and (max-width: 768px){
      max-width: 300px;
    }
  }
  .ticket-detail{
    font-size: 0.85em;
    margin-bottom: unset;
    font-weight: 400;

  }
  .dropdown-button{
    height: fit-content;
    width: fit-content;
    padding: 0;
  }
  .dropdown-menu-container{
    height: fit-content;
    position: relative;
    .dropdown-menu-list{
      padding-left: unset;
      padding-bottom: 0.5em;
      padding-top: 0.5em;
      z-index: 10;
      position: absolute;
      right: 0;
      top: 2em;
      list-style: none;
      border-radius: 0.358rem;
      box-shadow: 0 5px 25px rgba(47, 47, 47, 0.1);
      background: white;
      .dropdown-menu-item {
        white-space: nowrap;
        padding:0.5em 2em;
        cursor: pointer;

        &:hover{
          background: #EBE4EA;
          color: #9F6096;
        }
      }
    }
  }

}
</style>
